"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmountComponentsAtNodes = void 0;
// (C) 2019-2020 GoodData Corporation
var react_dom_1 = require("react-dom");
function unmountComponentsAtNodes(elementSelectors, _a) {
    if (elementSelectors === void 0) { elementSelectors = []; }
    var _b = _a === void 0 ? {
        unmount: react_dom_1.unmountComponentAtNode,
        documentInstance: document,
    } : _a, unmount = _b.unmount, documentInstance = _b.documentInstance;
    elementSelectors.forEach(function (elementSelector) {
        var element = documentInstance.querySelector(elementSelector);
        if (element) {
            unmount(element);
        }
    });
}
exports.unmountComponentsAtNodes = unmountComponentsAtNodes;
//# sourceMappingURL=domHelper.js.map